import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { DisappearingEntity } from "../../entity";

export class GetAllDisappearingDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => DisappearingEntity)
  data!: DisappearingEntity[];

  @Expose()
  @IsNumber()
  count!: number;

  @Expose()
  @IsNumber()
  page!: number;

  @Expose()
  @IsNumber()
  pageSize!: number;
}
